import React from 'react';
import { CircularProgress, makeStyles } from '@material-ui/core';
import { useQuery } from 'react-query';
import { getLocationDetails } from 'web/src/app/user-management/api/api';

export const LocationReviewItem = ({ locationId }) => {

    const { data, isLoading } = useQuery(["locationDetails", locationId], () => getLocationDetails(locationId))
    const styles = useStyles()

    return (
        <div className={styles.root}>
            {isLoading ? <CircularProgress size={24} />
                : (
                    <>
                        <div className={styles.locationName}>{data.name}</div>
                        <div className={styles.path}>{data.locations_path}</div>
                    </>
                )}

        </div>
    )

}

const useStyles = makeStyles(theme => ({
    path: {
        color: "#A0A0A0"
    },
    locationName: {
        fontWeight: "bold"
    },
    root: {
        padding: 16,
        minHeight: 70,
    },
}))